var OrderBundleArticle = /*@__PURE__*/ (function () {
    function OrderBundleArticle() {
        this.errors = [];
    }
    OrderBundleArticle.prototype.setId = function (id) {
        this.id = id;
        return this;
    };
    OrderBundleArticle.prototype.getId = function () {
        return this.id;
    };
    OrderBundleArticle.prototype.setName = function (name) {
        this.nam = name;
        return this;
    };
    OrderBundleArticle.prototype.getName = function () {
        return this.nam;
    };
    OrderBundleArticle.prototype.setPrice = function (price) {
        this.prc = price;
        return this;
    };
    OrderBundleArticle.prototype.getPrice = function () {
        return this.prc;
    };
    OrderBundleArticle.prototype.setRec = function (rec) {
        this.rec = rec;
        return this;
    };
    OrderBundleArticle.prototype.getRec = function () {
        return this.rec;
    };
    OrderBundleArticle.prototype.setValid = function (valid) {
        this.valid = valid;
        return this;
    };
    OrderBundleArticle.prototype.getValid = function () {
        return this.valid;
    };
    OrderBundleArticle.prototype.addError = function (error) {
        this.errors.push(error);
        return this;
    };
    OrderBundleArticle.prototype.getErrors = function () {
        return this.errors;
    };
    OrderBundleArticle.prototype.setImage = function (image) {
        this.img = image;
        return this;
    };
    OrderBundleArticle.prototype.getImage = function () {
        return this.img;
    };
    return OrderBundleArticle;
}());
export { OrderBundleArticle };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/order/order.bundle-article.ts
// module id = null
// module chunks = 